module.exports = __webpack_public_path__ + "static/media/FLY WITH US.eba6cb8c.jpg";